import Vue from 'vue';
import Title from '@/modules/bcube-assistant/components/BbnxBcubeAssistantTitle.vue';
import Subtitle from '@/modules/bcube-assistant/components/BbnxBcubeAssistantSubtitle.vue';
import SocialNetworkSummary from '@/modules/bcube-assistant/components/BbnxBcubeAssistantSocialNetworkSummary.vue';

Vue.component(Title.name, Title);
Vue.component(Subtitle.name, Subtitle);
Vue.component(SocialNetworkSummary.name, SocialNetworkSummary);
